import { Component, Input, OnInit } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';

import { EntityIconDataModel, EntityModel } from 'src/app/model';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-tile-body-asset-track',
  templateUrl: './tile-body-asset-track.component.html',
  styleUrls: ['./tile-body-asset-track.component.css']
})
export class TileBodyAssetTrackComponent implements OnInit {

  @Input() content: EntityModel;

  @Input() pageType: 'people' | 'assets' | 'vehicles';

  @Input() iconList: EntityIconDataModel[];

  blobSasToken: string = ApiConstants.blobSasToken;

  constructor(
    public service: EntitiesServiceService
  ) { }

  ngOnInit(): void { }

  getIconData(sourceCategory: string) {
    return this.iconList?.find((data) => data?.category === sourceCategory);
  }

}
